<template>
  <div class="main">
    <PushPermissionModal ref="pushModal" @activated="onPushActivated" />
    <h1 v-if="!loading">Herzlich Willkommen!</h1>
    <div class="enter-group-wrapper">
      <div class="enter-group" v-if="(!isAdmin && 1 == 0) && !loading">
        <h2>Du bist noch kein Mitglied bei einer Gruppe.</h2>
        <form v-on:submit.prevent="joinPool">
          <input type="text" placeholder="Einladungs-Code" id="new_group_name" v-model="inviteCode">
          <p class="error" v-if="errorMsg">{{errorMsg}}</p>
          <div class="form-item center">
            <button type="submit">Beitreten</button>
          </div>
        </form>
      </div>
      <div class="enter-group" v-if="(isAdmin || 1 == 1) && step === 0">
        <div>
          <h2>Du benutzt die App zum ersten Mal.</h2>
          <!--<p>Was möchtest du tun?</p>-->
        </div>
        <div class="action_choice">
          <button @click="step = 'create_group'"><img src="@/assets/images/group_add.svg">Gruppe erstellen</button>
          <button @click="step = 'join_group'"><img src="@/assets/images/group.svg">Gruppe beitreten</button>
        </div>
      </div>
      <div class="enter-group" v-if="(isAdmin || 1 == 1) && step === 'create_group'">
        <button class="back_button" @click="step = 0"><img src="@/assets/images/back.svg">Zurück</button>
        <h2>Erstelle jetzt deine Gruppe</h2>
        <div class="form-wrapper">
        <div class="form-item">
          <label for="new_group_name">Gruppenname</label>
          <input type="text" id="new_group_name" v-model="newGroupName">
        </div>
        <div class="form-item">
          <label for="new_group_description">Beschreibung</label>
          <textarea id="new_group_description" v-model="newGroupDescription"></textarea>
        </div>
        <div class="form-item" v-if="1 == 2"> <!-- hide image upload for now because it was creating a profile we did not want, i have to fix this first-->
          <label>Bild</label>
          <div class="upload-image-btn-container">
            <button v-if="!newGroupImage" class="upload-image" @click="openUploadDialog()">Bild hochladen</button>
            <img v-if="newGroupImage" :src="newGroupImage_URL" style="max-height: 100px; border-radius: 10px;"/>
          </div>
        </div>
        <div class="form-item center">
          <button @click="createPool()">Erstellen</button>
        </div>
      </div>
      </div>
      <div class="enter-group" v-if="step === 'join_group'">
        <button class="back_button" @click="step = 0"><img src="@/assets/images/back.svg">Zurück</button>
        <h2>Gruppe beitreten</h2>
        <form v-on:submit.prevent="joinPool">
          <div class="form-item">
            <label for="new_group_name">Einladungs-Code</label>
            <input type="text" id="new_group_name" v-model="inviteCode" placeholder="Code eingeben...">
            <p class="error" v-if="errorMsg">{{errorMsg}}</p>
          </div>
          <div class="form-item center">
            <button type="submit">Beitreten</button>
          </div>
        </form>
        <div v-if="availablePools && availablePools.length > 0" class="available-pools-section">
          <div class="divider">
            <span>oder direkt beitreten</span>
          </div>
          <div class="available-pools-list">
            <div 
              v-for="pool in availablePools" 
              :key="pool.id" 
              class="available-pool-card"
            >
              <div class="pool-info">
                <h3>{{ pool.name }}</h3>
                <p v-if="pool.description">{{ pool.description }}</p>
              </div>
              <button class="join-btn" @click="joinPoolDirectly(pool.code)">Beitreten</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AuthService from '@/services/AuthService.js';
import PushPermissionModal from '@/components/PushPermissionModal.vue';
export default {
  "name": "HomeView",
  components: { PushPermissionModal },
  data() {
    return {
      isAdmin: false,
      isNew: false,
      step: 0,
      newGroupName: null,
      newGroupDescription: null,
      newGroupImage: null,
      newGroupImage_URL: null,
      inviteCode: null,
      errorMsg: null,
      loading: true,
      availablePools: [],
      pushActivated: false,
    }
  },
  methods: {
    logout() {
      this.$store.dispatch('logout');
      this.$router.push('/login');
    },
    onPushActivated() {
      this.pushActivated = true;
    },
    async checkAndShowPushModal() {
      if (sessionStorage.getItem('push_modal_dismissed')) return;
      if (!('PushManager' in window)) return;
      if (Notification.permission === 'denied') return;
      try {
        const result = await AuthService.getPushActivationStatus();
        if (result.success && result.msg) {
          this.pushActivated = true;
          return;
        }
      } catch (e) {
        console.warn('Push-Status konnte nicht geprüft werden', e);
      }
      setTimeout(() => {
        this.$refs.pushModal?.show();
      }, 800);
    },
    async createPool() {
      this.msg = await AuthService.createPool({"new_group_name": this.newGroupName, "new_group_description": this.newGroupDescription});
      if (this.msg.success) {
        if(this.newGroupImage) this.uploadImage(this.newGroupImage, this.msg.newPoolId)
        this.$router.push('/pool-settings?pool=' + this.msg.newPoolId)
      } else {
        this.msg = this.msg.msg
      }
    },
    async joinPool() {
      try {
        this.msg = await AuthService.joinPool({"invite_code": this.inviteCode.toUpperCase()});
        if (this.msg.success) {
          await this.redirectAfterJoin(this.msg.newPoolId)
        } else {
          this.msg = this.msg.msg
          console.log(this.msg)
        }
      } catch (e) {
        console.error(e)
        this.errorMsg = e.response.data.msg
      }
    },
    async redirectAfterJoin(poolId) {
      // make the new group immediately clear as the active one everywhere else in the app
      try {
        AuthService.updateSelectedPool({selected_pool: poolId})
        this.$store.dispatch('updateLastSelectedPool', {pool_id: poolId})
      } catch(e) {
        console.error(e)
      }

      // if the user has no profile in this pool yet, send them straight to profile creation
      // instead of the group detail page, so it's immediately obvious what to do next
      try {
        let profileCheck = await AuthService.getUserProfileFromPool({pool_id: poolId})
        if (profileCheck.success && profileCheck.msg.length === 0) {
          this.$router.push('/account?create=1&joined=1&pool=' + poolId)
          return
        }
      } catch (e) {
        console.error(e)
      }
      this.$router.push('/pool-settings?pool=' + poolId + '&joined=1')
    },
    async getJoinedPools() {
      console.log("getting joined pools")
      try {
        this.msg = await AuthService.getUserJoinedPools()
        if (this.msg.success && this.msg.msg.length > 0) {
          this.$router.push("/match")
        }
      } catch (e) {
        console.error(e)
        this.errorMsg = e.response.data.msg
      }
    },
    openUploadDialog(){
      let input = document.createElement('input');
      input.type = 'file';
      input.onchange = () => {
        this.newGroupImage_URL = URL.createObjectURL(input.files[0]);
        this.newGroupImage = input.files[0];
      };
      input.click();
    },
     async uploadImage(file, pool_id) {
      this.newGroupImage = file

      const formData = new FormData();
      formData.append('image', this.newGroupImage);
      formData.append('pool_id', pool_id);

      try {
        this.uploadingImage = true
        let result = await AuthService.uploadImage(formData, {headers: {'Content-Type': 'multipart/form-data'}})
        this.uploadingImage = false
        if(result.success) {
          console.log(result)
          return true
        }
      } catch (e) {
        console.error(e)
        return false
      }
    },
    async getAvailablePools() {
      try {
        const res = await AuthService.getAvailablePools();
        console.log(res)
        if (res.success) {
          this.availablePools = res.msg;
        }
      } catch (e) {
        console.error(e);
      }
    },
    async joinPoolDirectly(code) {
      try {
        this.msg = await AuthService.joinPool({"invite_code": code.toUpperCase()});
        if (this.msg.success) {
          await this.redirectAfterJoin(this.msg.newPoolId)
        } else {
          this.errorMsg = this.msg.msg;
        }
      } catch (e) {
        console.error(e)
        this.errorMsg = e.response.data.msg
      }
    },
  },
  async beforeCreate() {
    if (!this.$store.getters.isLoggedIn) {
      this.$router.push('/login');
    }
  },
  async mounted() {
    try {
      this.msg = await AuthService.getUser()
      this.isNew = !!this.msg.msg[0].isNew;
      this.isAdmin = !!this.msg.msg[0].isAdmin;
    } catch(e){
      console.error(e)
    }
    await this.getJoinedPools();
    await this.getAvailablePools();
    this.loading = false;
    await this.checkAndShowPushModal();
  }
}
</script>
<style scoped>
.main {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 20px;
  background: transparent;
}

h1 {
  font-size: 2.2rem;
  font-weight: 800;
  letter-spacing: -0.02em;
  margin-bottom: 40px;
  color: var(--text-on-gradient);
}

h2 {
  font-size: 1.4rem;
  font-weight: 700;
  margin-bottom: 12px;
  letter-spacing: -0.01em;
}

p {
  color: var(--text-on-gradient);
  opacity: 0.9;
  font-size: 1rem;
  margin-bottom: 24px;
}

.enter-group-wrapper {
  width: 100%;
  max-width: var(--mid-width);
  margin-bottom: 100px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.enter-group {
  background: var(--card-bg);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-radius: var(--radius-xl);
  padding: 32px;
  box-shadow: var(--shadow-strong);
  color: #1D1D1F;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  text-align: center;
}

.form-wrapper {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.form-item {
  display: flex;
  flex-direction: column;
  text-align: left;
  gap: 8px;
}

label {
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--text-secondary);
  margin-left: 4px;
}

input, textarea {
  font-family: var(--font);
  font-size: 1rem;
  padding: 14px 18px;
  border-radius: var(--radius-m);
  border: 1px solid var(--border-color);
  background: #F5F5F7;
  transition: all 0.2s ease;
  outline: none;
}

input:focus, textarea:focus {
  border-color: var(--primary-color);
  background: white;
  box-shadow: 0 0 0 4px rgba(0, 122, 255, 0.1);
}

textarea {
  min-height: 100px;
  resize: vertical;
}

button {
  font-weight: 600;
  border-radius: var(--radius-m);
  padding: 14px 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

button[type="submit"], .form-item.center button {
  background: var(--primary-color);
  color: white;
  width: 100%;
  margin-top: 12px;
}

.action_choice {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.action_choice button {
  background: white;
  color: var(--text-main);
  border: 1px solid var(--border-color);
  aspect-ratio: 1;
  flex-direction: column;
  box-shadow: var(--shadow-soft);
}

.action_choice button:hover {
  border-color: var(--primary-color);
  background: #F5F5F7;
}

.action_choice button img {
  width: 32px;
  height: 32px;
  margin-bottom: 8px;
  filter: none; /* Icons should be visible on white bg */
}

.back_button {
  background: none;
  color: var(--primary-color);
  padding: 0;
  margin-bottom: 20px;
  font-size: 0.9rem;
  width: fit-content;
}

.back_button img {
  width: 18px;
  filter: invert(34%) sepia(87%) saturate(5451%) hue-rotate(200deg) brightness(101%) contrast(105%);
}

.upload-image-btn-container {
  margin-top: 8px;
}

.upload-image {
  background: white;
  color: var(--primary-color);
  border: 1px dashed var(--primary-color);
}

.available-pools-section {
  margin-top: 28px;
  text-align: left;
}

.divider {
  display: flex;
  align-items: center;
  text-align: center;
  color: var(--text-secondary);
  font-size: 0.85rem;
  font-weight: 600;
  margin-bottom: 20px;
}

.divider::before,
.divider::after {
  content: '';
  flex: 1;
  border-bottom: 1px solid var(--border-color);
}

.divider:not(:empty)::before {
  margin-right: 12px;
}

.divider:not(:empty)::after {
  margin-left: 12px;
}

.available-pools-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-height: 250px;
  overflow-y: auto;
  padding-right: 4px;
}

/* Custom scrollbar for pools list */
.available-pools-list::-webkit-scrollbar {
  width: 6px;
}
.available-pools-list::-webkit-scrollbar-track {
  background: transparent;
}
.available-pools-list::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 3px;
}

.available-pool-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px;
  background: #F5F5F7;
  border: 1px solid var(--border-color);
  border-radius: var(--radius-m);
  transition: all 0.2s ease;
}

.available-pool-card:hover {
  background: white;
  border-color: var(--primary-color);
  box-shadow: var(--shadow-soft);
}

.pool-info {
  flex: 1;
  min-width: 0;
}

.pool-info h3 {
  font-size: 1rem;
  font-weight: 700;
  margin: 0 0 4px 0;
  color: #1D1D1F;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.pool-info p {
  font-size: 0.85rem;
  color: var(--text-secondary);
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  opacity: 0.8;
}

.join-btn {
  background: var(--primary-color);
  color: white;
  padding: 8px 16px;
  font-size: 0.85rem;
  font-weight: 600;
  border-radius: var(--radius-s);
  border: none;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.2s ease, transform 0.1s ease;
}

.join-btn:hover {
  background: #0066d6;
}

.join-btn:active {
  transform: scale(0.95);
}
</style>
